export const urlbase = "https://api.gestionale-napla.it/api/";
export const urllogin = urlbase + "auth/login";
export const urlrefresh = urlbase + "auth/refresh";
export const urlutenti = urlbase + "utenti";
export const urltask = urlbase + "tasks";
export const urleventi = urlbase + "eventi";
export const urlcontratti = urlbase + "contratti-quadro";
export const urlcommittenti = urlbase + "committenti";
export const urlcantiere = urlbase + "cantiere";
export const urlprofilo = urlutenti + "/profilo";
export const urlreferenti = urlbase + "referenti";
export const urlmetodi = urlbase + "metodi";
export const urlfiles = urlbase + "files";
export const urlstati = urlbase + "stati";
